import axios from 'axios';
import i18n from 'roddeh-i18n';
import { dispatch, } from './social-auth';
/** Wyświetl błąd autoryzacji użytkownikowi */
const showErrors = (data) => {
    let error;
    if (typeof data.message === 'undefined') {
        error = i18n('An unknown error occurred. Please try again later');
    }
    else {
        error = data.message;
    }
    const errorModal = document.createElement('tc-modal');
    errorModal.innerHTML = error;
    document.body.append(errorModal);
    errorModal.open();
};
/** Przycisk, dla którego wykonano inicjalizację logowania */
let logInButton = null;
/** Funkcja obsługująca pozytywną odpowiedź z próby logowania poprzez Google */
const handleCredentialResponse = (response) => {
    // Token JWT z danymi użytkownika, podpisany przez Google
    const { credential } = response;
    // Wysyłamy token do backendu w celu weryfikacji
    axios
        .post('/google/tokensignin', { token: credential })
        .then((response) => {
        if (!response.data.logged && response.data.email) {
            let firstName = '';
            let lastName = '';
            if (response.data.first_name) {
                firstName = response.data.first_name;
            }
            if (response.data.last_name) {
                lastName = response.data.last_name;
            }
            dispatch('signed', {
                type: 'account_created',
                source: 'Google',
                firstName: firstName,
                lastName: lastName,
                email: response.data.email,
            }, logInButton);
        }
        else {
            if (response.data.logged) {
                const data = {
                    type: 'logged',
                    firstName: response.data.first_name,
                    lastName: response.data.last_name,
                };
                if (typeof response.data.redirect_to !== 'undefined') {
                    data.redirectTo = response.data.redirect_to;
                }
                dispatch('signed', data, logInButton);
            }
            else {
                console.error('Received success response that was not logged or registration');
                showErrors({});
                dispatch('canceled', {}, logInButton);
            }
        }
    })
        .catch((err) => {
        console.error('/google/tokensignin failure', err);
        const data = {};
        if (typeof err.response !== 'undefined') {
            if (typeof err.response.data.message !== 'undefined') {
                data.message = err.response.data.message;
            }
            if (typeof err.response.data.errors !== 'undefined') {
                data.errors = err.response.data.errors;
            }
        }
        showErrors(data);
        dispatch('canceled', data, logInButton);
    });
};
/** Inicjalizacja modułu po jego załadowaniu */
const init = () => {
    // Konfiguracja API Google
    const clientID = window.__STATE__?.functions.google_auth_client_id;
    if (clientID === null || typeof clientID === 'undefined') {
        console.error('Tried to initialize Google Auth Button but client id was not found in __STATE__');
        return;
    }
    window.google.accounts.id.initialize({
        client_id: clientID,
        callback: handleCredentialResponse,
    });
    // Inicjalizacja przycisku
    const button = document.querySelector('#google-auth-button');
    if (button === null || !(button instanceof HTMLElement)) {
        console.error('Failed to initialize Google Auth Button: #google-auth-button not found');
        return;
    }
    // Wymuś CSSy wyśrodkowujące przycisk
    button.style.display = 'flex';
    button.style.justifyContent = 'center';
    // Wyrenderuj przycisk
    window.google.accounts.id.renderButton(button, { width: 288 });
    logInButton = button;
};
export default () => {
    if (document.readyState === 'complete') {
        init();
    }
    else {
        window.addEventListener('load', () => {
            init();
        });
    }
};
